const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m348 512h-184c-66.168 0-120-53.832-120-120v-272c0-66.168 53.832-120 120-120h184c66.168 0 120 53.832 120 120v272c0 66.168-53.832 120-120 120zm-184-472c-44.112 0-80 35.888-80 80v272c0 44.112 35.888 80 80 80h184c44.112 0 80-35.888 80-80v-272c0-44.112-35.888-80-80-80zm192 338.889c0-51.219-41.818-92.889-93.22-92.889h-13.56c-51.402 0-93.22 41.67-93.22 92.889 0 11.046 8.954 20 20 20s20-8.954 20-20c0-29.163 23.875-52.889 53.22-52.889h13.56c29.346 0 53.22 23.726 53.22 52.889 0 11.046 8.954 20 20 20s20-8.954 20-20zm-98-125.889c-39.701 0-72-32.299-72-72s32.299-72 72-72 72 32.299 72 72-32.299 72-72 72zm0-104c-17.645 0-32 14.355-32 32s14.355 32 32 32 32-14.355 32-32-14.355-32-32-32z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.aff462187eb3f7f9eb30460ae7a47aca.svg";
export { ForwardRef as ReactComponent };